import axios from "axios"
import { apiBase, apiToken } from "./store"
// import config from "./config"
import { get } from "svelte/store"

let token

apiToken.subscribe((t) => {
    token = t
})

/*
let _apiBase = window.localStorage.getItem("apiBase")
if (!_apiBase) {
    _apiBase = get(apiBase)
    window.localStorage.setItem("apiBase", _apiBase)
}
*/

export const api = () => {
    const _apiBase = get(apiBase)
    console.log("using apiBase: ", _apiBase)
    return axios.create({
        baseURL: _apiBase,
        responseType: "json",
        headers: {
            token,
        },
    })
}
